import { CloseButton, Dialog } from '@chakra-ui/react'
import { ResponsiveModal } from '../shared'
import { ContactCreateForm, type ContactCreateContext } from './ContactCreateForm'

export interface ContactCreateModalProps {
  isOpen: boolean
  onClose: () => void
  context: ContactCreateContext
  onCreated: (contactId: string) => void
}

export function ContactCreateModal({ isOpen, onClose, context, onCreated }: ContactCreateModalProps) {
  const handleDone = (contactId: string) => {
    onCreated(contactId)
    onClose()
  }

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} size="lg" scrollBehavior="inside">
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content maxH="90vh">
          <Dialog.Header>Add contact</Dialog.Header>
          <Dialog.CloseTrigger asChild><CloseButton size="sm" /></Dialog.CloseTrigger>
          <Dialog.Body maxH="calc(90vh - 80px)" overflowY="auto">
            <ContactCreateForm context={context} onDone={handleDone} />
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </ResponsiveModal>
  )
}
